import { ReferenceTableNameSetEvent, } from '../event/reference-table-name-set.event';
const referenceTableNameSetProjections = {
    [ReferenceTableNameSetEvent.name]: (event, state) => ({
        ...state,
        ...event.getPayload(),
    }),
};
export default referenceTableNameSetProjections;
//# sourceMappingURL=reference-table-name-set.projection.js.map